module.exports = __webpack_public_path__ + "img/plate01_01.2ca99473.png";